import script from "./TemplateBuilder.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateBuilder.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateBuilder.vue?vue&type=style&index=0&id=00526844&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00526844"]])

export default __exports__